import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col, Switch } from "antd";
import "./RcuControl.css";

class RcuControlWithChild extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  areAllFalse = (obj) => {
    return Object.values(obj).every((value) => value === false);
  };

  // 将 Title 转换为显示文本
  getTitleText = (title) => {
    const titleMap = {
      "master": "Master",
      "bathroom": "Bathroom",
      "bathroom.m": "Master Bathroom",
      "bathroom.2": "Bathroom 2",
      "bedroom": "Bedroom",
      "bedroom.m": "Master Bedroom",
      "bedroom.2": "Bedroom 2",
      "livingroom": "Living Room",
      "diningroom": "Dining Room",
    };
    return titleMap[title] || title;
  };

  // 将子项 key 转换为显示文本
  getSubItemText = (title, key) => {
    const subItemMap = {
      "master": {
        "bright": "Bright",
        "soft": "Soft",
      },
      "bathroom": {
        "bright": "Bright",
        "soft": "Soft",
      },
      "bathroom.m": {
        "bright": "Bright",
        "soft": "Soft",
      },
      "bathroom.2": {
        "bright": "Bright",
        "soft": "Soft",
      },
      "bedroom": {
        "bright": "Bright",
        "soft": "Soft",
        "night": "Night",
        "readingleft": "Reading Left",
        "readingright": "Reading Right",
        "table": "Table",
        "closet": "Closet",
      },
      "bedroom.m": {
        "bright": "Bright",
        "soft": "Soft",
        "night": "Night",
        "readingleft": "Reading Left",
        "readingright": "Reading Right",
      },
      "bedroom.2": {
        "bright": "Bright",
        "soft": "Soft",
        "night": "Night",
        "reading": "Reading",
        "reading2l": "Reading 2L",
      },
      "livingroom": {
        "bright": "Bright",
        "soft": "Soft",
      },
      "diningroom": {
        "bright": "Bright",
        "soft": "Soft",
      },
    };
    return subItemMap[title]?.[key] || key;
  };

  getTrueProperties = (obj) => {
    const { Title } = this.props;

    return Object.keys(obj)
      .filter((key) => obj[key])
      .map((key) => this.getSubItemText(Title, key))
      .join(", ");
  };

  render() {
    const { ColSpan, Title, Icon, Device, Handlers, ShowDetail } = this.props;
    const allFalse = this.areAllFalse(Device);
    const trueProperties = this.getTrueProperties(Device);

    return (
      <Col span={ColSpan ?? 12} className="col-rcu-menu-wrap">
        <Row>
          <Col span={24} className="col-rcu-menu">
            <div
              className={
                allFalse ? "div-rcu-menu" : "div-rcu-menu div-rcu-menu-on"
              }
              onClick={() => {
                if (!allFalse) {
                  if (Handlers["turnAllOff"]) {
                    Handlers["turnAllOff"]();
                  }
                }

                Handlers["setShowDetail"]();
              }}
            >
              <img
                src={require(`../../assets/image/client_controller/${Icon}`)}
                alt="Icon"
              />
              <div className="div-rcu-menu-info">
                <div className="div-rcu-menu-info-title">
                  {this.getTitleText(Title)}
                </div>
                <div className="div-rcu-menu-info-control">
                  {trueProperties ? trueProperties : "Off"}
                </div>
              </div>
            </div>
            <>
              {ShowDetail ? (
                <div className="div-rcu-menu-control">
                  {Object.keys(Device).map((key) => (
                    <div key={key} className="div-rcu-menu-control-item">
                      <Switch
                        size="small"
                        checked={Device[key]}
                        onChange={() => {
                          if (Handlers[key]) {
                            Handlers[key]();
                          }
                        }}
                      />{" "}
                      {this.getSubItemText(Title, key)}
                    </div>
                  ))}
                </div>
              ) : null}
            </>
          </Col>
        </Row>
      </Col>
    );
  }
}

RcuControlWithChild.propTypes = {
  ColSpan: PropTypes.number,
  Title: PropTypes.string,
  Icon: PropTypes.string,
  Device: PropTypes.object.isRequired,
  Handlers: PropTypes.object.isRequired,
  ShowDetail: PropTypes.bool,
};

export default RcuControlWithChild;
